export default function smoothScrollInit(props) {
    const {
        offsetTopDelta,
        scrollSpeedTime,
    } = props

    const animateScroll = ( $elementToScroll, offsetTopDelta, scrollSpeedTime ) => {
        jQuery('html, body').animate({
            scrollTop: $elementToScroll.offset().top - offsetTopDelta
        }, scrollSpeedTime, 'linear')
    }

    /**
     * Manual scrolling to anchor for new page loading
     */
    if ( window.location.hash !== '' ) {
        const $elementToScroll = jQuery( window.location.hash )

        if ( $elementToScroll.length ) {
            scroll(0,0);

            setTimeout(function() {
                scroll(0,0);
            }, 1);

            animateScroll( $elementToScroll, offsetTopDelta, scrollSpeedTime );
        }
    }

    /**
     * Manual scrolling to anchor for current page
     */
    jQuery('a[href*="#"]').on('click', function(event) {
        const link = new URL( this.href )
        const windowLink = new URL( window.location.href )

        /**
         * If clicked link is not equal current link, just exit
         */
        if ( link.pathname !== windowLink.pathname ) {
            return true
        }

        event.preventDefault()

        const $elementToScroll = jQuery( link.hash )

        if ( $elementToScroll.length ) {
            // history.pushState({}, this.text, link.href)

            animateScroll( $elementToScroll, offsetTopDelta, scrollSpeedTime );
        }
    })
}